// src/components/LoginForm.js
import React, { useEffect, useState } from "react";
import axios from "axios";

const LoginForm = () => {

  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);
  const [loadingMe, setLoadingMe] = useState(false);
  const [errorMe, setErrorMe] = useState<string | null>(null);
  
  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    setToken(savedToken);
  }, []);

  React.useEffect(() => {
    // kalau token belum ada → jangan panggil apa-apa
    if (!token) {
      setUser(null);
      return;
    }

    const fetchMe = async () => {
      try {
        setLoadingMe(true);
        setErrorMe(null);

        const baseUrl = process.env.strapiUrl;

        const res = await fetch(`${baseUrl}/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!res.ok) {
          throw new Error(`Failed to fetch /auth/me: ${res.status}`);
        }

        const json = await res.json();
        localStorage.setItem('user', JSON.stringify(json));
        setUser(json);

      } catch (err: any) {
        console.error("Error fetch /auth/me:", err);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setErrorMe(err.message || "Gagal mengambil informasi user");
      } finally {
        setLoadingMe(false);
      }
    };

    fetchMe();
  }, [token]);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    console.log("Form Submitted:", formData);

    const payload = {
      identifier: formData.username,
      password: formData.password,
    }

    const result = await login(payload);

    if (result) {
      // contoh redirect ke dashboard setelah registrasi
      // window.location.href = "/dashboard";
      console.log("TODO:", "make academy.marvinfoundation.org subdomain for webinar");
    }
  };

  const login = async (formData: {
    identifier: string;
    password: string;
  }) => {
    try {
      const baseUrl = process.env.strapiUrl;
      const response = await axios.post(`${baseUrl}/auth/local`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data) {
        const { jwt } = response.data;

        // Simpan ke localStorage
        localStorage.setItem('token', jwt);
        setToken(jwt);

        alert("Login berhasil!");
        console.log("Response:", response.data);
  
        return response.data;
      }
    } catch (error: any) {
      let message = "";

      if (error.response?.data?.error?.message) {
        message = error.response.data.error.message;
      } else {
        message = error.message;
      }

      alert(`Registrasi gagal: ${message}`);
      console.error("Error:", error);
      throw error;
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="form_wrapper_body">
        <p className="login-username">
          <label>Email</label>
          <input
            type="text"
            name="username"
            placeholder="Email"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </p>
        <p className="login-password">
          <label>Password</label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </p>
      </div>
      <div className="form_wrapper_footer">
        <input className="button" type="submit" value="Login" />
        <a className="button" href="/register">
          Register
        </a>
      </div>
    </form>
  );
};

export default LoginForm;
